export function routeRequiresAuthentication(route) {
    return !route.matched.some(routeRecord => routeRecord.meta?.requiresAuthentication === false);
}
